import React, { useEffect, useState } from 'react';

import { 
    Card,
    CardBody
} from 'reactstrap';

import FullSpinner from 'components/Common/FullSpinner';
import PageBase from 'components/Common/PageBase';
import Filters from './Filters';
import HeaderReport from './HeaderReport';
import TableReport from './TableReport';
import { TypeForm } from './Ajustaments/TypeForm';
import useRequest from 'hooks/useRequest';
import OffCanvas from '../../common/OffCanvas';
import '../../../../assets/scss/reports/daily-movements.scss';
import moment from 'moment';
import { getAccountingAcounts } from 'store/accounting-accounts/actions';
import { useDispatch } from 'react-redux';
import { getInventoryReport } from '../../../../helpers/backend_helper';

const initialPeriod = moment().startOf('month').format('YYYY-MM-DD') + '/' + moment().endOf('month').format('YYYY-MM-DD');

const breadcrumbList = [
    { id: '1', title: 'Administrativo', active: false },
    { id: '2', title: 'Reportes', active: false },
    { id: '3', title: 'Existencias y valuación de Inventario', active: true }
];

export default function Inventory() {

    const dispatch = useDispatch();
    const [ isRight, setIsRight ] = useState(false);
    const [ isNew, setIsNew ] = useState(false);
    const [ reportType, setReportType ] = useState('DAILY');
    const [ period, setPeriod ] = useState(initialPeriod);
    const [ columnOrder, setColumnOrder ] = useState({
        column: '',
        order: ''
    });

    const {
        column,
        order
    } = columnOrder;

    const {
        data,
        isLoading,
        req
    } = useRequest();

    const toggleRightCanvas = () => {
        setIsRight(!isRight);
    }

    const handleFilters = ({ periodo, providers, product}) => {
        const config = {
            params: {
                period: periodo,
                providers,
                column,
                order,
                product
            }
        };
        req(getInventoryReport(config));
    }

    useEffect(() => {
        
        dispatch(getAccountingAcounts());
    }, []);
    
    return (
        <>  
            { isLoading && <FullSpinner /> }
            <PageBase
                titleMeta="Reporte Existencias y valuación de Inventario"
                titleBread="Reporte Existencias y valuación de Inventario"
                itemsBread={ breadcrumbList }
            >
                <Card>
                    <CardBody>
                        <Filters
                            data={ data }
                            toggleRightCanvas={toggleRightCanvas}
                            setPeriod={ setPeriod }
                            columnOrder={ columnOrder }
                            period={period}
                            setIsNew={setIsNew}
                            handleFilters={handleFilters}
                        />
                    </CardBody>
                </Card>                
                <Card>
                    <CardBody> 
                        <OffCanvas 
                            isNew={ isNew }
                            isRight={ isRight }
                            toggleRightCanvas={ toggleRightCanvas }
                            reportTitle={ 'Ajuste de Inventario' }
                        >
                            <TypeForm 
                                    isNew={ isNew }
                                    toggleRightCanvas={ toggleRightCanvas }
                                />
                        </OffCanvas>                 
                        { data && data.report.length ? (
                            <>
                                <HeaderReport 
                                    period={ period }
                                    totals={ data.totals }
                                />
                                <TableReport 
                                    balanceInitial={data.balance_initial}
                                    data={ data.report } 
                                    totals={ data.totals }
                                    setColumnOrder={ setColumnOrder }
                                    columnOrder={ columnOrder }

                                />
                                
                            </>
                        ) : <p>No hay datos con el periodo seleccionado</p>}
                    </CardBody>
                </Card>
            </PageBase>
        </>
    );
}